<pcp-slide-sync-toolbar-button
        [matIcon]="icon"
        [fontSet]="fontSet"
        (toggle)="toggle()"
        [turnedOn]="(isActivated$ | async) === true"
        [disabled]="(isDrawingEnabled$ | async) === false"
></pcp-slide-sync-toolbar-button>
